<template>
  <div class="progress-bar">
    <div class="progress-bar__content">
      <slot />
      <p class="progress-bar__text text-body-2xs-bold">
        {{ progressText }}
      </p>
    </div>

    <div class="progress-bar__bar">
      <span
        class="progress-bar__bar--filled"
        :style="{ width: `${ percentage }%` }"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Progress Bar (progress-bar)
 * -----------------------------------------------------------------------------
 * Progress bar that can show completion rate up to 100%.
 *
 * @param {Number} percentage - Percentage of the progress bar.
 * @param {String} progressText - Text that shown in progress bar information
 *
 */

export default {
  name: 'ProgressBar',

  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    progressText: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
@import 'progress-bar';
</style>
